function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
import color from 'color';
var CHECKBOX_STYLE = {
  display: 'inline-block',
  height: '20px',
  width: '20px',
  cursor: 'pointer'
};
export default (function (_ref) {
  var colors = _ref.colors;
  return {
    container: {
      paddingLeft: '35px',
      minHeight: '24px',
      '&:hover $checkbox': {
        borderBottom: "2px solid ".concat(colors.primary)
      },
      '&:hover $checkbox__checked': {
        backgroundColor: colors.primaryDarker,
        borderBottom: "2px solid ".concat(color(colors.primaryDarker).darken(0.2).hex())
      },
      '&:hover $checkbox__error': {
        backgroundColor: colors.white
      }
    },
    container__topMargin: {
      marginTop: '10px'
    },
    container__bottomMargin: {
      marginBottom: '25px'
    },
    wrapper: {
      display: 'flex'
    },
    label: {
      position: 'relative',
      userSelect: 'none',
      cursor: 'pointer',
      display: 'flex'
    },
    label__disabled: {
      opacity: 0.5,
      cursor: 'not-allowed',
      '& $checkbox, & $input': {
        cursor: 'not-allowed'
      }
    },
    checkboxLabel: {
      display: 'inline-block',
      paddingTop: '2px',
      verticalAlign: 'top',
      fontSize: '14px'
    },
    input: _objectSpread({
      position: 'absolute',
      opacity: 0,
      left: '-9999px'
    }, CHECKBOX_STYLE),
    checkbox__bordered: {
      border: "1px solid ".concat(colors.inputBorder)
    },
    checkbox: _objectSpread({
      position: 'absolute',
      left: '-35px',
      borderBottom: "2px solid ".concat(colors.inputBorder),
      borderRadius: '2px 2px 0 0',
      backgroundColor: colors.white,
      transition: 'background-color 0.2s, border-color 0.2s',
      textAlign: 'center'
    }, CHECKBOX_STYLE),
    checkbox__focused: {
      borderBottom: "2px solid ".concat(colors.primary)
    },
    checkbox__checked: {
      backgroundColor: colors.primary,
      border: colors.primary,
      borderBottom: "2px solid ".concat(colors.primaryDarker)
    },
    checkbox__error: {
      border: color(colors.error).lighten(0.6).hex(),
      backgroundColor: color(colors.error).lighten(0.6).hex(),
      borderBottom: "2px solid ".concat(colors.error)
    },
    icon: {
      fill: colors.white,
      width: '11px',
      height: '11px'
    },
    fade: {
      maskImage: 'linear-gradient(to bottom, black 40%, transparent 100%)'
    },
    scrollable: {
      overflow: 'scroll !important'
    },
    noScrollbar: {
      scrollbarWidth: 'none',
      '&::-webkit-scrollbar': {
        display: 'none'
      }
    },
    button: {
      width: '100%',
      height: '25px',
      justifyContent: 'center',
      backgroundColor: 'transparent',
      border: 'none',
      cursor: 'pointer',
      '&:active': {
        backgroundColor: 'rgba(0, 0, 0, .015)'
      },
      outline: 'none'
    },
    chevron: {
      width: '15px',
      height: '15px',
      transition: 'transform 500ms',
      fill: colors.secondary
    },
    chevronOpen: {
      transform: 'rotate3d(1, 0, 0, 180deg)'
    },
    scrollButtons: {
      display: 'flex',
      flex: 1,
      justifyContent: 'space-between',
      flexDirection: 'column'
    },
    scrollButton: {
      display: 'flex',
      width: 23,
      height: 23,
      borderRadius: 2,
      backgroundColor: '#77869F',
      color: 'white',
      border: 'none',
      alignItems: 'center',
      outline: 'none',
      cursor: 'pointer'
    },
    scrollChevron: {
      fill: 'white',
      width: '100%',
      height: '100%'
    },
    up: {
      transform: 'rotate3d(1, 0, 0, 180deg)'
    }
  };
});